import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalstorageService {

  setLocalStorageItem(key : string, value : any) {
    localStorage.setItem(key, decodeURIComponent(value));
  }

  removeLocalStorageItem(key : string) {
    localStorage.removeItem(key);
  }

  getLocalStorageItem(key : string) {
    return localStorage.getItem(key)
  }
  
}
